export default __webpack_public_path__ + "static/Poppins-SemiBold-ac8d04b620e54be9b0f0f4851d56e4dd.ttf";